import * as React from 'react';
import { useEffect, useState } from "react";
import * as VolumePromotionLevelFactory from "../../classes/definitions/volumePromotionLevel/volumePromotionLevel";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import VolumePromotionLevelForm from "../../components/AdjustmentLevels/AdjustmentLevelForm/VolumePromotionLevelForm";
import AppRoutes from "../../config/appRoutes";
var VolumePromotionLevel = function (props) {
    var http = new HttpRequests();
    var api = new ApiRequests();
    var _a = useState(""), id = _a[0], setId = _a[1];
    var _b = useState(""), levelId = _b[0], setLevelId = _b[1];
    var _c = useState(), level = _c[0], setLevel = _c[1];
    var toListPage = function () {
        props.history.push(AppRoutes.volumePromotion.path + "/" + id + AppRoutes.volumePromotionsLevels.path);
    };
    var handleSubmit = function (updateLevel) {
        var submitData = new FormData();
        submitData.append("level[from_quantity]", "" + updateLevel.FromQuantity);
        submitData.append("level[to_quantity]", "" + updateLevel.ToQuantity);
        submitData.append("level[percent_adjustment]", "" + updateLevel.PercentAdjustment);
        var action = !levelId ? api.createLevelForVolumePromotion(id, submitData) : api.updateLevelFromVolumePromotion(id, levelId, submitData);
        action.then(function () {
            toListPage();
        })
            .catch(function (error) {
            var defaultMessage = 'Грешка при създаване';
            var editMessage = "Грешка при ъпдейт";
            http.handleError(error, props.messages, levelId ? editMessage : defaultMessage, props.history);
        });
    };
    useEffect(function () {
        var _a;
        var _b = ((_a = props === null || props === void 0 ? void 0 : props.match) === null || _a === void 0 ? void 0 : _a.params) || {}, _c = _b.id, paramId = _c === void 0 ? "" : _c, _d = _b.levelId, paramLevel = _d === void 0 ? "" : _d;
        setId(paramId);
        setLevelId(paramLevel);
        if (paramLevel && paramId) {
            api.getLevelForVolumePromotion(paramId, paramLevel)
                .then(function (res) {
                var editableLevel = VolumePromotionLevelFactory.createVolumePromotionLevel(res.data.data.attributes, paramLevel);
                setLevel(editableLevel);
            })
                .catch(function (error) {
                var defaultMessage = 'Неуспешно взимане на информация';
                http.handleError(error, props.messages, defaultMessage, props.history);
            });
        }
    }, []);
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u0438\u0432\u043E \u0437\u0430 \u043F\u0440\u043E\u043C\u043E\u0446\u0438\u044F"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-5" },
                    React.createElement(VolumePromotionLevelForm, { onSubmit: handleSubmit, level: level }))))));
};
export default VolumePromotionLevel;



//////////////////
// WEBPACK FOOTER
// ./src/views/VolumePromotions/VolumePromotionLevel.tsx
// module id = 513
// module chunks = 0